import React, { createContext, useState } from "react";

export const TextContext = createContext<{
  text: string;
  setText: React.Dispatch<React.SetStateAction<string>>;
}>({ text: "", setText: () => {} });

export function TextProvider({
  children,
}: React.PropsWithChildren): React.ReactElement {
  const [text, setText] = useState("");
  // ...
  return (
    <TextContext.Provider value={{ text, setText }}>
      {children}
    </TextContext.Provider>
  );
}
